// extracted by mini-css-extract-plugin
export default {"loading_container":"CircleLoading_loading_container__WjlgT","rotation":"CircleLoading_rotation__KZKuZ"};